// InputField.js
import { FormHelperText, InputLabel, OutlinedInput } from "@mui/material";
import { Field, ErrorMessage } from "formik";
import React from "react";

const InputField = ({ label, required, ...props }) => {
  return (
    <>
      <InputLabel htmlFor={props.id || props.name}>
        {label}
        {required && <span style={{color:'red'}}>*</span>}
      </InputLabel>
      <Field as={OutlinedInput} {...props} />
      <ErrorMessage name={props.name}>
        {(error) => (
          <FormHelperText error id={`${props.name}-error`}>
            {error}
          </FormHelperText>
        )}
      </ErrorMessage>
    </>
  );
};

export default InputField;
